module.exports = __webpack_public_path__ + "img/product2_11B984_range.bcc1e641.png";